import {
  SR_API_ACTION_ADD_LISTING_TO_TOUR,
} from 'api/actionTypes';
import {
  TOUR_SHOWING_SOURCE_AGENT,
} from 'common/tourConstants';

import getAgentTours from './getAgentTours';

export default async function addListingToTour(
  { state, history, apiClient },
  { listingId, userId, tourId, agentUserId },
) {
  await apiClient.postWithState({
    action: SR_API_ACTION_ADD_LISTING_TO_TOUR,
    state: state,
    payload: {
      listingId,
      userId,
      tourId,
      source: TOUR_SHOWING_SOURCE_AGENT,
    },
    onSuccess() {
      history.push('/agent/tours');
    },
  });

  return getAgentTours({ state, history, apiClient }, { agentUserId });
}
